import React from 'react';
export const Mention = ({ children, node: { mentionedUser }, }) => (React.createElement("span", { className: 'str-chat__message-mention', "data-user-id": mentionedUser.id }, children));
